import React, { Component } from 'react';
import { Breadcrumb } from 'semantic-ui-react'
import Draggable from 'react-draggable';
import { Link } from "react-router-dom";

import Api from '../services/api.js'
import { getText, createSearchParams, markItemAsReviewed } from '../helpers';

class TemplateUpdateModal extends Component {
  constructor(props){
    super(props)

    this.state = {
      pendingReviews: props.pendingReviews
    }
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      pendingReviews: nextProps.pendingReviews
    })
  }

  onMarkAsReviewed = (reviewId) => {
    markItemAsReviewed(reviewId, this.props.refreshPendingReviews);
  }

  onMarkAsInScope = (review) => {
    let { id, plan_id, work_phase_or_ambient_exposure='', activity='', hazard='', unwanted_event='' } = review;
    const search_term = `${work_phase_or_ambient_exposure.trim()} / ${activity.trim()} / ${hazard.trim()} / ${unwanted_event.trim()}`;

    const params = {
      plan_id,
      search_term,
      column_name: "unwanted_event",
      hidden: false
    }

    const api = new Api();
    api.put("/__api/v1/toggle_by_level", params)
    .then(response => {
      if (response.status !== 200) return;
      this.onMarkAsReviewed(id);

      if (this.props.callbackForMarkAsInScope) this.props.callbackForMarkAsInScope(); 
    })
    .catch(err => console.log(err));

  }

  createItemLocation = (review) => {
    const params = { ...review, search_item_in_scope: true };
    const searchParamsStr = createSearchParams(params).toString();

    return {
      pathname: `/plan/${review.plan_id}/activities`,
      search: searchParamsStr
    }
  }

  highlightReviewItem = (review) => {
    const { work_phase_or_ambient_exposure: expandedWorkPhaseCard='', activity: expandedActivityCard='', hazard: expandedHazardCard='' } = review;
    this.props.setExpandedCards({ expandedWorkPhaseCard, expandedActivityCard, expandedHazardCard })
  }

  render() {
    const { require_review, close, review_instruction, mark_as_reviewed, reviewed } = this.props.translations;
    const { parentView } = this.props;
    return (
      <Draggable handle=".template-changes-alert-close">
        <div className={ "template-changes-alert " + this.props.shown }>
          <div className="template-changes-alert-close">
            <b>{require_review}</b>
            <a onClick={ () => this.props.onClose() }>{close}</a>
            <div id="instructions">
              {review_instruction}
            </div>
          </div>
          <div className="template-changes-alert-content">
            {
              this.state.pendingReviews.map((review, index) => {
                return (
                  <Breadcrumb className="template-changes-alert-list" key={ index }>
                    <Breadcrumb.Section><span class="ui label text work-phase">{getText('Work Phase or Ambient Exposure')}</span>{ review.work_phase_or_ambient_exposure }</Breadcrumb.Section>
                    <Breadcrumb.Divider />
                    <Breadcrumb.Section><span class="ui label text activity">{getText('Activity')}</span>{ review.activity }</Breadcrumb.Section>
                    <Breadcrumb.Divider />
                    <Breadcrumb.Section><span class="ui label text hazard">{getText('Hazard (Risk Source)')}</span>{ review.hazard }</Breadcrumb.Section>
                    <Breadcrumb.Divider />
                    <Breadcrumb.Section><span class="ui label text unwanted-event">{getText('(Unwanted) Event')}</span>{ review.unwanted_event }</Breadcrumb.Section>
                    <Breadcrumb.Divider icon='' />
                    <Breadcrumb.Section className="review-buttons">
                      {
                        parentView === 'Project Control Register'
                        ?
                        <Link className="mark-as-in-scope" to={this.createItemLocation(review)} target="_blank">{getText('Go to Item in Scope View')}</Link>
                        :
                        <a className='mark-as-in-scope' onClick={ () => this.highlightReviewItem(review) }>{getText('Go to Item in Scope View')}</a>
                      }
                      <a className='mark-as-in-scope' onClick={ () => this.onMarkAsInScope(review) }>{getText('Mark as In Scope and Reviewed')}</a>
                      { review.reviewed ? <span style={{color:"green"}}>{reviewed}</span> : <a onClick={ () => this.onMarkAsReviewed(review.id) }>{mark_as_reviewed}</a> }
                    </Breadcrumb.Section>
                  </Breadcrumb>
                )
              })
            }
          </div>
          <div className="template-changes-alert-close" />
        </div>
      </Draggable>
    )
  }
}

export default TemplateUpdateModal



// WEBPACK FOOTER //
// ./src/components/template_update_alert.js